export default "__VITE_ASSET__D3N0S3qO__"